import { render, staticRenderFns } from "./sidebarWeb.vue?vue&type=template&id=509d459a&scoped=true"
import script from "./sidebarWeb.vue?vue&type=script&lang=js"
export * from "./sidebarWeb.vue?vue&type=script&lang=js"
import style0 from "./sidebarWeb.vue?vue&type=style&index=0&id=509d459a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d459a",
  null
  
)

export default component.exports